// Keep server aggregates (which can include unloaded deals) and adjust only the moved deal.
export function moveDealBetweenStages(stages, leadId, destinationId, destinationIndex = 0) {
    const source = stages.find(stage => stage.leads.some(lead => String(lead.id) === String(leadId)));
    const destination = stages.find(stage => String(stage.id) === String(destinationId));
    if (!source || !destination) return stages;
    if (source === destination) {
        const current = source.leads.findIndex(lead => String(lead.id) === String(leadId));
        const items = [...source.leads];
        const [lead] = items.splice(current, 1);
        items.splice(Math.max(0, Math.min(destinationIndex, items.length)), 0, lead);
        return stages.map(stage => stage === source ? { ...stage, leads: items } : stage);
    }
    const lead = source.leads.find(item => String(item.id) === String(leadId));
    const amount = Number(lead.total) || 0;
    const insertionIndex = Math.max(0, Math.min(destinationIndex, destination.leads.length));
    return stages.map(stage => {
        if (stage === source) return {
            ...stage,
            leads: stage.leads.filter(item => String(item.id) !== String(leadId)),
            cant_deals: Math.max(0, Number(stage.cant_deals ?? stage.leads.length) - 1),
            suma_ingreso: (Number(stage.suma_ingreso) || 0) - amount,
        };
        if (stage === destination) return {
            ...stage,
            leads: [...stage.leads.slice(0, insertionIndex), { ...lead, id_etapa: destination.id }, ...stage.leads.slice(insertionIndex)],
            cant_deals: Number(stage.cant_deals ?? stage.leads.length) + 1,
            suma_ingreso: (Number(stage.suma_ingreso) || 0) + amount,
        };
        return stage;
    });
}

export function movementNeighbors(stages, leadId, stageId) {
    const stage = stages.find(item => String(item.id) === String(stageId));
    const index = stage.leads.findIndex(lead => String(lead.id) === String(leadId));
    return { id_etapa: stage.id, after_id: stage.leads[index - 1]?.id ?? null, before_id: stage.leads[index + 1]?.id ?? null };
}

export function applyMovement(stages, leadId, intent) {
    const destination = stages.find(stage => String(stage.id) === String(intent.id_etapa));
    if (!destination) return stages;
    const items = destination.leads.filter(lead => String(lead.id) !== String(leadId));
    const before = items.findIndex(lead => String(lead.id) === String(intent.before_id));
    const after = items.findIndex(lead => String(lead.id) === String(intent.after_id));
    return moveDealBetweenStages(stages, leadId, destination.id, before >= 0 ? before : after >= 0 ? after + 1 : items.length);
}
